import { SVGProps } from 'react';

export const CheckIconV2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="10" viewBox="0 0 102 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.00012 52.938L26.7881 69.5421C31.865 73.8021 39.4341 73.1399 43.6941 68.063L94.9319 7.00015"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinecap="round"
    />
  </svg>
);
